var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as R from 'ramda';
import { marker2FormPath } from './reducer-helper';
export var mapFreeFormStateKeys = function (params) {
    var applicationCode = params.applicationCode, applicationGroup = params.applicationGroup, applicationVersion = params.applicationVersion, freeFormCode = params.freeFormCode;
    var processInstanceId = 'free_forms';
    var taskDefinitionKey = applicationGroup + "." + applicationCode + "/" + applicationVersion + "/" + freeFormCode;
    return { processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey };
};
export var selectForms = function (state) { return R.prop('forms', state); };
export var selectFormMounted = function (state) { return R.prop('mounted', selectForms(state)); };
export var selectFormsMarker = function (state) { return R.prop('marker', selectForms(state)); };
export var selectFormsInternalStatus = function (state) { return R.prop('internalStatus', selectForms(state)); };
export var selectFormsError = function (state) { return R.prop('error', selectForms(state)); };
export var selectFormsLoading = function (state) { return R.prop('isLoading', selectForms(state)); };
export var selectFormsSubmitting = function (state) { return R.prop('isSubmitting', selectForms(state)); };
export var selectFormsBusy = function (state) {
    return R.pipe(selectForms, function (_a) {
        var isLoading = _a.isLoading, isSubmitting = _a.isSubmitting;
        return isLoading || isSubmitting;
    })(state);
};
export var selectForm = function (processInstanceId, taskDefinitionKey, modalFormCode) { return function (state) {
    return R.path(__spreadArrays([
        'items',
        processInstanceId,
        taskDefinitionKey
    ], (R.isNil(modalFormCode) ? ['form'] : ['children', modalFormCode])), selectForms(state));
}; };
export var selectFreeForm = function (applicationGroup, applicationCode, applicationVersion, freeFormCode) {
    var _a = mapFreeFormStateKeys({
        applicationGroup: applicationGroup,
        applicationCode: applicationCode,
        applicationVersion: applicationVersion,
        freeFormCode: freeFormCode,
    }), processInstanceId = _a.processInstanceId, taskDefinitionKey = _a.taskDefinitionKey;
    return selectForm(processInstanceId, taskDefinitionKey, null);
};
export var selectCurrentForm = function (state) {
    var formPath = R.pipe(selectFormsMarker, marker2FormPath)(state);
    return formPath.length ? R.path(formPath, selectForms(state)) : null;
};
//# sourceMappingURL=selectors.js.map